export const ROLES = {
  operations: {
    key: "operations",
    name: "OPERATIONS",
    shortLabel: "OPS",
    color: "#0C98D0",
    description: [
      "Access to Sites, Subjects, Safety, Measures*, and Data*",
      "*All except those associated with clinical measures beyond baseline",
    ],
    noteClass: "text-xs text-[#00000073]",
  },
  safety: {
    key: "safety",
    name: "SAFETY",
    shortLabel: "SAFETY",
    color: "#991962",
    description: [
      "Access to Subjects, Safety, Measures*, and Data*",
      "*All except those associated with clinical measures beyond baseline",
    ],
    noteClass: "text-xs text-[#00000073]",
  },
  clinical: {
    key: "clinical",
    name: "CLINICAL",
    shortLabel: "CLINICAL",
    color: "#387853",
    description: [
      "Access to Subjects, Measures*, and Data*",
      "*Only those associated with clinical measures",
    ],
    noteClass: "text-xs text-[#00000073]",
  },
  admin: {
    key: "admin",
    name: "ADMIN",
    shortLabel: "ADMIN",
    color: "#2B4752",
    description: ["Access to all screens"],
  },
  cro: {
    key: "cro",
    name: "CRO",
    shortLabel: "CRO",
    color: "#BCA048",
    description: [
      "Access to Subjects, Protocol Deviations, Screening, and Sites",
    ],
  },
  full_access: {
    key: "fullaccess",
    name: "FULL ACCESS",
    shortLabel: "FULL ACCESS",
    color: "#DF7934",
    description: ["Full access to all screens"],
  },
} as const;

export type RoleKey = keyof typeof ROLES;
export type RoleConfig = {
  key: string;
  name: string;
  shortLabel: string;
  color: string;
  description: string[];
  noteClass?: string;
};
